import { ContinueWithGoogle } from '../../components/ContinueWithGoogle'
import { FormEvent, useEffect, useState } from 'react'
import { Input, preventSpaceInput } from '../../components/FormElements/Input'
import { useTranslation } from 'react-i18next'
import { useWhoAmI } from '../../hooks/queries/useWhoAmI'
import { persistUrlParameters, getUrlParameters } from '../../helpers/urls'
import { setNewAccessToken } from '../../infrastructure/apis'
import { useNavigate } from 'react-router-dom'

export const LoginMethods = () => {
    const navigate = useNavigate()
    const { t } = useTranslation('signIn')
    const [email, setEmail] = useState('')
    const [error, setError] = useState<string>()
    const onError = ({ response }: any) => setError(response.data.message)

    useEffect(() => {
        persistUrlParameters()

        const { token, courseId } = getUrlParameters()

        if (!token) return

        setNewAccessToken(token as string)
        navigate(courseId ? `/dashboard/${courseId}` : '/')

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const { refetch, isFetching } = useWhoAmI({
        email,
        onError,
    })

    const onSubmit = (event?: FormEvent<HTMLFormElement>) => {
        event?.preventDefault()
        refetch()
    }

    return (
        <>
            <h1 className="title">{t('Log in')}</h1>

            <ContinueWithGoogle />

            <form onSubmit={onSubmit}>
                <Input
                    {...{
                        id: 'email',
                        name: 'email',
                        label: t('Email'),
                        autoComplete: 'username',
                        type: 'email',
                        placeholder: 'username@mail.com',
                        required: true,
                        disabled: isFetching,
                        value: email ?? '',
                        onChange: ({ target: { value } }) => {
                            setError(undefined)
                            setEmail(value.trim())
                        },
                        onKeyDown: preventSpaceInput,
                        error: t(error!) ?? undefined,
                    }}
                />
                <br />
                <button className="primary w-100" children={t('Log in')} disabled={!email || isFetching || !!error} />
            </form>

            <br />
        </>
    )
}

export default LoginMethods
